import videoBackground from "../videos/landing-background.mp4";

const SignupBanner = () => {
  return (
    <div className="signup-banner">
      {videoBackground && (
        <video
          autoPlay
          loop
          muted
          playsInline
          src={videoBackground}
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
          }}
        />
      )}
    </div>
  );
};

export default SignupBanner;
